<template>
    <div class="container">
        <div v-if="logoutSplash" class="logout-splash">
        <span>{{ logoutMessage }}</span>
        </div>
        <div class="edit-profile-top">
            <div class="row">
                <span class="edit-profile" @click="backProfile()">
                    <img src="../assets/arrow-back.png" alt="" width="25px"> Bank
                </span>
            </div>
           
            <div class="profile-content">
                <div class="column1">
                    <span class="label">
                        Account name
                    </span>
                    <input type="hidden" class="input-textx" v-model="userid">
                    <input type="text" class="input-textx" v-model="account_name" placeholder="Enter account name">
                    
                    <div class="phone-gender mt-3">
                        <span class="label">
                        Bank name
                    </span>
                    <input type="text" class="input-phone" v-model="bank_name" placeholder="Enter bank name">
                    <span class="label">
                        Account number
                    </span>
                    <input type="text" class="input-phone" v-model="account_number" placeholder="Enter account number">
                    </div>
                </div>
            </div>

            <div class="button-container">
                <button class="btn-save" @click="save()">
                    Save
                   
                </button>
            </div>
        </div>

        <div v-if="splashScreen">
            <transition name="modal" >
                <div class="modal-mask">
                    <div class="modal-wrapper col-md-4" style="margin:auto">
                            <div class="profile-view2">
                                <hr style="color:#3E3D3D; margin-top:-20px">
                                <span class="profile-bio2">
                                     <p style="font-size:x-large">
                                        <i class="fas fa-spinner"></i> Processing...
                                     </p>
                                </span>
                            </div>
                    </div>
                </div>
            </transition>
        </div> 
        <div class="loader" v-if="pageLoader">
            <span class="dot"></span> 
            <span class="dot"></span>
            <span class="dot"></span>
        </div>

        <v-dialog v-model="showImageDialog" max-width="800px">
        <v-card>
            <v-img :src="selectedImage" aspect-ratio="1.5" contain></v-img>
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="pink darken-1" @click="showImageDialog = false">Close</v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>
    </div>
</template>
<script>

//import userInterests from '../components/UserInterests';
import swal from 'sweetalert2';
export default {

    components: {
        //userInterests,        
    },
    
    data() {
    return {
        pageLoader: false,
        image_path: '',
        splashScreen: false,
        selectedImage: null,
        showImageDialog: false,
        profile: true,
        edit_profile: false,
        btn_success: false,
        previewImage:'',
        previewImage2: '',
        myprofile: '',
        age: '',
        fullname: '',
        firstname:'',
        middlename: '',
        lastname: '',
        email: '',
        phone: '',
        day: '',
        month: '',
        year: '',
        gender: '',
        location: '',
        state: '',
        aboutyou: '',
        occupation: '',
        religion: '',
        sexuality: '',
        relationship_goal: '',
        loading: false,
        loading2: false,
        musicx: '',
        dancex: '',
        foodx: '',
        fashionx: '',
        photographyx: '',
        travelx: '',
        cookingx: '',
        userphoto: '',
        country: '',
        profile_pictures:[],
        options: [],
        transport: '',
        activeTab: 'gallery',
        tabs: [
            { name: 'gallery', label: 'Gallery' },
            { name: 'videos', label: 'Videos' },
            { name: 'rate', label: 'Rates' },
            { name: 'preferences', label: 'Preferences' },
            { name: 'review', label: 'Review' },
            { name: 'follows', label: 'Followers' }
        ],
        pricingOptions: [
        { value: "negotiable", text: "Negotiable" },
        { value: "5k", text: "₦5,000" },
        { value: "10k", text: "₦10,000" },
        { value: "15k", text: "₦15,000" },
        { value: "premium", text: "₦20,000 and above" },
        ],

        options3: [

            {
                value: "Gay",
                text: "Gay",
            },
            {
                value: "Lesbian",
                text: "Lesbian",
            },
            {
                value: "Bisexual",
                text: "Bisexual",
            },
            {
                value: "Straight",
                text: "Straight",
            },
            {
                value: "I'd prefer not to say",
                text: "I'd prefer not to say",
            },
        ],
        options4: [
        {
            value: "My fare must be covered",
            text: "My fare must be covered",
        },
        {
            value: "I'll find my own way there",
            text: "I'll find my own way there",
        },
        {
            value: "I prefer to be picked up",
            text: "I prefer to be picked up",
        },
        {
            value: "I'll need return fare too",
            text: "I'll need return fare too",
        },
        {
            value: "Only available within my area",
            text: "Only available within my area",
        }
        ],

        options5: [

            {
                value: "3",
                text: "3 Months",
            },
            {
                value: "6",
                text: "6 Months",
            },
            {
                value: "12",
                text: "One Year",
            },
            
        ],
        photos: '',
        profile_photo: '',
        userid: '',
        escort_data: '',
        yearsList: [],
        profilePictureFile: null,
        slogan: '',
        logoutSplash: false,
        logoutMessage: ""
        };
    },

beforeMount(){
    this.userid =  this.$route.params.escortid;
    this.editProfile(this.userid);
},

mounted(){

},

methods: {
    

    backProfile() {
    // Go to previous page
    this.$router.go(-1);
    },


    async editProfile(userid){
        const response = await this.$http.post('/list-profile',{ user_id: userid}, {
            headers: { 
                //"x-api-key": `${process.env.VUE_APP_API_KEY}`,
                'Content-Type': 'application/json' 
               },
        })
            this.escort_data = response.data.data[0];
            const birthday = this.escort_data.birthday.split('-')
            this.username = this.escort_data.username,
            this.fullname= this.escort_data.name,
            this.email = this.escort_data.email_address,
            this.phone = this.escort_data.phone_number,
            this.day = birthday[2].split("T")[0],
            this.month = birthday[1],
            this.year = birthday[0],
            this.gender = this.escort_data.gender,
            this.country = this.escort_data.country,
            this.state = this.escort_data.state,
            this.location = this.escort_data.location,
            this.aboutyou = this.escort_data.bio,
            this.slogan = this.escort_data.slogan
    },

    async save() {
    try {
        // Optional: Validate required fields (can be more tailored)
        if (!this.account_name || !this.bank_name || !this.account_number) {
         // Set splash message
         this.logoutMessage = "Please fill all required fields.";
         this.logoutSplash = true;
        // Wait before redirecting
         setTimeout(() => {
         this.logoutSplash = false;
        }, 2500); // splash visible for 2.5 seconds
        return;
        }

        this.loading = true;

        // Send request
        const response = await this.$http.post('/create-bank', {
            userid: this.userid,
            account_name: this.account_name,
            bank_name: this.bank_name,
            account_number: this.account_number,
        });

        this.loading = false;

        if (response.data.success) {
        // Set splash message
        this.logoutMessage = response.data.message || "Successful!";
        this.logoutSplash = true;
        // Wait before redirecting
        setTimeout(() => {
        this.logoutSplash = false;
        }, 2500); // splash visible for 2.5 seconds

        // Optional: Clear or redirect
        this.$router.go(-1);
        } else {
        swal.fire({
            icon: 'warning',
            width: 450,
            text: response.data.message,
        });
        }
    } catch (err) {
        console.error(err);
        this.loading = false;
        swal.fire({
        icon: 'error',
        title: 'Server Error',
        text: err.response ? err.response.data.message : err.message,
        });
    }
    },
  }
}

</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans&family=Raleway&display=swap');
.logout-splash {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  font-family: 'Raleway';
  font-style: normal;
  background-color: #0A070F; /* green success */
  color: white;
  padding: 15px;
  text-align: center;
  font-weight: bold;
  z-index: 9999;
  box-shadow: 0 2px 5px rgba(0,0,0,0.3);
  transition: top 0.3s ease-in-out;
}

.nav-link{
    color: #D33E74;
}
 .nav-tabs .nav-link {
    cursor: pointer;
 }

    .nav-tabs .nav-link.active {
        background-color: #D33E74;
        color: white;
        border-radius: 0.25rem;
    }

.loader{
    width:100%;
    height:300px;
    display:flex;
    align-items:center;
    justify-content:center;
    gap:20px;
    margin-top:-300px
  }
  .mobile-line{
    display: flex;
    color: #767475;
    width: 90%;
}
  .dot{
    height:40px;
    width:40px;
    border-radius:50%;
  }
  
  .dot:nth-child(1){
    background-color:red;
    animation: jump 0.6s 0.5s ease-in infinite
  }
  .dot:nth-child(2){
    background-color:blue;
    animation: jump 0.6s 0.7s ease-in infinite
  }
  .dot:nth-child(3){
    background-color:orange;
    animation: jump 0.6s 0.9s ease-in infinite
  }
  
  
  @keyframes jump{
    0%{
      transform: translate3D(0,0,0);
      opacity: 0;
    }
      50%{
      transform: translate3D(0,-15px,0);
        opacity: 0.5;
    }
      100%{
      transform: translate3D(0,0,0);
        opacity: 1;
    }
  }
.modal-mask {
    // position: fixed;
     z-index: 9998;
     top: 0;
     left: 0;
     //width: 100%;
     height: 100%;
     background: rgba(0, 0, 0, .5) !important;
     display: table;
     transition: opacity .3s ease;
     & > div {
         //width: 100%;
         height: 120px;
         position: absolute;
         top: 50%;
         left: 50%;
         transform: translate(-50%, -50%);
         //padding: 2em;
         border: 1px solid #2F2F2F;
         //backdrop-filter: blur(13px);
         background: #19181B;
         border-radius: 20px;
         box-sizing: border-box;
       }
       .profile-view2{
         box-sizing: border-box;
         border-radius: 20px;
         //position:relative;
         width: 100%;
         height: 100%;
         background: #111112;
         .profile-photo2{
             width: 100%;
             height: auto;
             background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 59.17%, rgba(0, 0, 0, 0.5) 80.14%), #2F2F2F;
         }
     }


     .profile-interest2{
         
         h3 {
             width: auto;
             height: 26px;
             font-family: 'DM Sans';
             font-style: normal;
             font-weight: 700;
             font-size: 20px;
             line-height: 26px;
             text-align: left;
             color: #FFFFFF;
             margin:20px;
         }
         .interests2{
             box-sizing: border-box;
             display: flex;
             flex-direction: row;
             justify-content: center;
             align-items: center;
             padding: 2px 8px;
             width: auto;
             height: 29px;
             background: #111112;
             border: 1px solid #D33E74;
             border-radius: 50px;
             color: #767475;
             font-size: 10px;
             margin: 4px;
 
         }
 
         .interests-info2 {
             display: flex;
             flex-direction: row;
             //padding: 0rem 3rem 5rem 1rem;
         }
     }
     .profile-relationship-goal2 {
         margin-top: -150px !important;
         h3 {
             width: auto;
             height: 26px;
             font-family: 'DM Sans';
             font-style: normal;
             font-weight: 700;
             font-size: 20px;
             line-height: 26px;
             text-align: left;
             color: #FFFFFF;
             margin:20px;
         }
         .relationship-goal2 {
             display: flex;
             flex-direction: row;
             padding: 2px;
             width: 70%;
             height: auto;
             background: rgba(255, 214, 0, 0.1);
             border-radius: 61px;
             color: #FFD600;
             font-size: 10px;
             margin: 20px;
             text-align: left;
         }
 
     }
     .btn-unmatch-report2 {
         display: flex;
         flex-direction: row;
         align-items: center;
         .btn-unmatch2 {
             box-sizing: border-box;
             display: flex;
             flex-direction: row;
             justify-content: center;
             align-items: center;
             padding: 10px;
             width: 55%;
             height: 30px;
             background: #111112;
             border: 1px solid #D33E74;
             border-radius: 82px;
             font-family: 'Source Sans 3';
             font-style: normal;
             font-weight: 400;
             font-size: 13px;
             line-height: 28px;
             color: #D33E74;
             margin: 20px;
             cursor: pointer;
         }
         .btn-unmatch3 {
             box-sizing: border-box;
             display: flex;
             flex-direction: row;
             justify-content: center;
             align-items: center;
             padding: 10px;
             width: 55%;
             height: 30px;
             background: #111112;
             border: 1px solid #D33E74;
             border-radius: 82px;
             font-family: 'Source Sans 3';
             font-style: normal;
             font-weight: 400;
             font-size: 13px;
             line-height: 28px;
             color: #b1acae;
             margin: 20px;
             cursor: pointer;
         }
         .btn-report2 {
             display: flex;
             flex-direction: row;
             justify-content: center;
             align-items: center;
             padding: 10px;
             width: 55%;
             height: 30px;
             background: #2D2D2D;
             border-radius: 82px;
             font-family: 'Source Sans 3';
             font-style: normal;
             font-weight: 400;
             font-size: 13px;
             line-height: 28px;
             color: #767475;
             margin-right: 10px;
             cursor: pointer;
         }
     }
   }
.content-fluid {
    background: transparent;
}
.container {
    margin-top: 80px;
    width: 100%;
    min-height: 80vh;
}
.profile-container{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}
.large-profile-pic {
  width: 140px;
  height: 140px;
  border-radius: 50%;
}

 .profile-image {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;


    .img-profile {
        width: 60%;
        height: 60%;
        margin:2px;
        border-radius: 100px;
    }

    .profile-info {
         padding: 0 0 0 20px;

        h3 {
            font-family: 'Raleway';
            font-style: normal;
            font-weight: bold;
            font-size: 25px;
            line-height: 20px;
            text-align: left;
            color: #FFFFFF;
        }
        p {
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 500;
            font-size: 15px;
            line-height: 20px;
            text-align: left;
            color: #FFFFFF;
        }        
    }
    .select-profile{
        background: linear-gradient(180deg, rgba(0, 0, 0, 0.08) 68.1%, rgba(0, 0, 0, 0.5) 78.43%), #2F2F2F;
        border: 3px solid #D33E74;
        border-radius: 50%;
        width: 145px;
        height: 145px;
        display: block;
        margin-top: 15px;
        margin-bottom: 25px;
    }
 }
.profile-edit-button{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

    .btn-edit {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 10px 18px;
        width: 120px;
        height: 40px;
        background: #D33E74;
        border: 0.5px solid #D33E74;
        border-radius: 50px;
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 21px;
        text-align: center;
        color: #FFFFFF;
    }
}

.photo {
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    font-size: 16px;
    line-height: 28px;
    text-align: left;
    color: #FFFFFF;
    margin-left: -45px;
    margin-top: 10px;

}

 .edit-profile-top {
    width: 100%;
 }
 .user-interests{
    display: flex;
    flex-wrap: wrap;
    gap: 10px; /* spacing between buttons */
 }

 .btn-chips {
  padding: 8px 16px;
  border: none;
  background-color: #eee;
  border-radius: 20px;
  cursor: pointer;
  font-family: 'DM Sans', sans-serif;
  transition: background-color 0.3s;
}

.btn-chips:hover {
  background-color: #ddd;
}

 .edit-profile {
    color: #FFFFFF;
    font-size: 12px;
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    line-height: 28px;
    //text-align: center;
    color: #FFFFFF;
    cursor: pointer;
 }
 .img-profile{
    display: flex;
    flex-direction: row;
    justify-content: center;
 }
 .img-profile-edit{
    margin-top: 50px;
    margin-bottom: 50px;
    text-align: center;
    .img-profile2 {
        width: 120px;
        height: 120px;
        background: url("../assets/no_image.png");
        background-size: cover;
        padding-bottom: 0rem;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        cursor: pointer;
        border-radius: 100px;
        //background: #D9D9D9;
    }
 }
 .profile-content{
    display: flex;
    flex-direction: row;
    justify-content: center;
 }
 .column1{
    width: 400px;
    margin: 10px;
 }
 .button-container{
    display: flex;
    flex-direction: row;
    justify-content: center;
 }
 .label{
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 26px;
    text-align: left;
    color: #FFFFFF;
    margin-left: 10px;
 }
 .input-textx {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 100%;
    height: 45px;
    background: #2D2D2D;
    border: 0 solid;
    border-radius: 50px;
    font-size: 12px;
    color: #fff !important;
 }
 .input-phone{
    box-sizing: border-box;
    padding: 10px 52px;
    width: 100%;
    height: 45px;
    background: #2D2D2D;
    border: 0px solid #FFFFFF;
    border-radius: 50px;
    font-size: 12px;
    color: #fff !important;
 }
  .input-gender{
    box-sizing: border-box;
    padding: 10px 52px;
    width: 100%;
    height: 45px;
    background: #2D2D2D;
    border: 0px solid #FFFFFF;
    border-radius: 50px;
    font-size: 12px;
    color: #fff !important;
 }
 .input-text-about{
    box-sizing: border-box;
    padding: 10px 52px;
    width: 100%;
    height: 55px;
    background: #2D2D2D;
    border: 0px solid #FFFFFF;
    border-radius: 50px;
    font-size: 12px;
    color: #fff !important;
 }
 .input-text {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 350px;
    height: 45px;
    background: #2D2D2D;
    border: 0.5px solid #FFFFFF;
    border-radius: 50px;
    font-size: 12px;
    color: #fff !important;
 }

 .input-text-state {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 350px;
    height: 45px;
    background: #2D2D2D;
    border: 0.5px solid #FFFFFF;
    border-radius: 50px;
    font-size: 12px;
    color: #fff !important;
 }
 .birthday{
    display: flex;
    flex-direction: row;
   
 }
 .phonegender{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
 }
 .input-select {
    box-sizing: border-box;
    align-items: center;
    padding: 10px 40px;
    width: 100%;
    height: 55px;
    background: #2D2D2D;
    border: 0px solid #FFFFFF;
    border-radius: 50px;
    color: #767475;
    font-size: 12px;
    margin: 2px;
}
.rel-goal{
    color:#D33E74;
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
}
.btn-save {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    width: 400px;
    height: 45px;
    background: #D33E74;
    border-radius: 82px;
    font-family: 'Source Sans 3';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 28px;
    color: #FFFFFF;
    margin-top: 15px;
    margin-bottom: 40px;
}

.btn-chips {
    box-sizing: border-box;
    justify-content: center;
    align-items: center;
    padding: 4px 10px;
    width: auto;
    height: 25px;
    margin: 3px;
    margin-bottom: 20px;
    background: #0A070F;
    border: 0.5px solid #D33E74;
    border-radius: 50px;
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 16px;
    text-align: center;
    color: #D33E74;
}      

@media screen and (max-width: 700px) {
    .container{
        margin-top: 100px;
        padding: 0px 0px 0px 0px !important;
    }
    .profile-container{
        display: flex;
        flex-direction: column;
 
    }
    .profile-image {
        display: flex;
        flex-direction: column;

        .img-profile {
            width: 30%;
            height: 30%;

        }
        .profile-info {
            padding: 0 0 0 0px;
            h3 {
                font-family: 'Raleway';
                font-style: normal;
                font-weight: bold;
                font-size: 25px;
                line-height: 20px;
                text-align: center;
                color: #FFFFFF;
            }
            p {
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 500;
                font-size: 14px;
                line-height: 20px;
                text-align: center;
                color: #FFFFFF;
            }
          
        }
        .select-profile{
            width: 145px;
            height: 145px;
        }
     }
    .profile-edit-button{

    
        .btn-edit {
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px 18px;
            width: 100px;
            height: 35px;
            background: #D33E74;
            border: 0.5px solid #D33E74;
            border-radius: 50px;
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 500;
            font-size: 10px;
            line-height: 21px;
            text-align: center;
            color: #FFFFFF;
        }
    }
    .mobile-line{
        color: #767475;
        width: 100%;
    }
    .photo {
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 800;
        font-size: 18px;
        line-height: 28px;
        text-align: left;
        color: #FFFFFF;
        margin-left: 55px;
        margin-top: 50px;
    }
 .edit-profile-top {
  margin-left: 0px;
 }

 .profile-content{
    display: flex;
    flex-direction: column;
 }
 .column1{
    width: 100%;
    margin: 0px;
 }
 .user-interests{
   
 }
 .edit-profile {
    color: #FFFFFF;
    font-size: 12px;
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    line-height: 28px;
    //text-align: center;
    color: #FFFFFF;
    cursor: pointer;
 }
 .img-profile-edit{
    margin-top: 50px;
    margin-bottom: 50px;

    .img-profile2 {
        width: 120px;
        height: 120px;
        background: url("../assets/no_image.png");
        background-size: cover;
        padding-bottom: 0rem;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        cursor: pointer;
        border-radius: 100px;

    }
 }
 .label{
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 26px;
    text-align: left;
    color: #FFFFFF;
    margin-left: 10px;
 }
 .input-text {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 100%;
    height: 35px;
    background: #0A070F;
    border: 0.5px solid #FFFFFF;
    border-radius: 50px;
    font-size: 12px;
 }
 .birthday{
    display: flex;
    flex-direction: column;
 }
 .input-select {
    box-sizing: border-box;
    align-items: center;
    padding: 10px 40px;
    width: 100%;
    height: 45px;
    background: #2D2D2D;
    border: 0px solid #FFFFFF;
    border-radius: 50px;
    color: #fff;
    font-size: 12px;
    margin: 2px;
}
.rel-goal{
    color:#D33E74;
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
   
}
.btn-save {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    width: 100%;
    height: 45px;
    background: #D33E74;
    border-radius: 82px;
    font-family: 'Source Sans 3';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 28px;
    color: #FFFFFF;
    margin-top: 15px;
}

}

</style>